import { Autocomplete, AutocompleteOption } from '@/components/ds2'

export interface RateconRevisionLoadSearchOption {
    revisionId: string
    loadId: string
    rateConfDocumentId: string
    position: number
}

interface RateconRevisionLoadSelectorProps {
    currentRevisionId: string
    options: RateconRevisionLoadSearchOption[]
    totalRevisions?: number
    disabled?: boolean
    onSelect?: (revisionId: string) => void
}

export const RateconRevisionLoadSelector = ({ currentRevisionId, options, totalRevisions, disabled = false, onSelect }: RateconRevisionLoadSelectorProps) => {
    if (options.length <= 1) return null

    const autocompleteLoadOptions: AutocompleteOption[] = options.map((option) => ({
        value: option.revisionId,
        label: `Load ${option.rateConfDocumentId} · Revision ${option.position}${totalRevisions ? ` of ${totalRevisions}` : ''}`,
        searchText: `${option.rateConfDocumentId} ${option.loadId}`,
    }))

    return (
        <div className="max-w-lg">
            <Autocomplete
                key={currentRevisionId}
                label="Search revised loads"
                options={autocompleteLoadOptions}
                placeholder="Search loads..."
                value={[]}
                onChange={(values) => {
                    const [revisionId] = values
                    if (revisionId) onSelect?.(revisionId)
                }}
                disabled={disabled}
                emptyMessage="No loads found"
            />
        </div>
    )
}
